import { Box } from '@mui/material';

import { MaterialSymbol } from '@/components/MaterialSymbol';

/**
 * The way back to a panel's overview, on the drawer's collapse row — "Show
 * project summary" from a task in Planning, and from a contract in Financials
 * (3 Nov, Mette: every right panel works the same way). Styled as a button —
 * light blue fill, blue outline (2026-10-08, the pilot's ask) — so it does not
 * read as a tag. Lifted from `planning/PlanDrawerHeading` when Financials
 * needed the same one.
 */
export type DrawerBackButtonProps = {
  label: string;
  onClick: () => void;
  automationId: string;
  /** Material Symbols glyph; the overview glyph by default. */
  icon?: string;
};

export const DrawerBackButton = ({
  label,
  onClick,
  automationId,
  icon = 'overview',
}: DrawerBackButtonProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 1 }}>
    <Box
      component="button"
      type="button"
      data-automation-id={automationId}
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.5,
        py: 0.5,
        border: 'var(--border-width-thin) solid var(--color-blue-80)',
        borderRadius: 'var(--border-radius-small)',
        bgcolor: 'var(--color-blue-10)',
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'var(--font-family)',
        color: 'var(--color-blue-100)',
        cursor: 'pointer',
        '&:hover': { bgcolor: 'var(--color-blue-20)' },
        '&:focus-visible': { outline: 'var(--focus-ring)', outlineOffset: '1px' },
      }}
    >
      <MaterialSymbol name={icon} size={16} />
      {label}
    </Box>
  </Box>
);
